/**
 * Centralized React Components Entry Point
 * This file exports all React components and their initialization functions
 */

import { initCompanyManagement } from './companies/CompanyManagement';
import { initUserManagement } from './users/UserManagement';
import { initApplicationManagement } from './applications/ApplicationManagement';

// Initialize components when DOM is ready
const initializeReactComponents = () => {
  // Initialize company management if element exists
  initCompanyManagement();
  
  // Initialize user management if element exists
  initUserManagement();
  
  // Initialize application management if element exists
  initApplicationManagement();
};

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeReactComponents);
} else {
  initializeReactComponents();
}

// Export for manual initialization if needed
export {
  initCompanyManagement,
  initUserManagement,
  initApplicationManagement,
  initializeReactComponents
};
